"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.find.js");
var _interopRequireWildcard2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
var _cookie = require("@/utils/cookie");
var _hike = require("@/api/hike");
var _log = require("@/utils/log");
var _lifehikesInitData = require("@/lifehikes-init-data");
var _lodash = _interopRequireDefault(require("lodash"));
var _index = _interopRequireDefault(require("../../../../components/EventTime/index.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const defaultValue = [];
var _default = exports.default = {
  name: 'HikeSurvey',
  components: {
    EventTime: _index.default
  },
  props: {
    parentId: {
      type: String,
      default: ''
    },
    parentStages: {
      type: Array,
      default: defaultValue
    },
    survey: {
      type: Object,
      default: null
    }
  },
  data() {
    // console.log('parentId:', this.parentId)
    // console.log('survey:', this.survey)

    return {
      loading: false,
      surveyForm: _lodash.default.cloneDeep(this.survey),
      surveyData: [{
        key: 'benchmarkSelfAssessment',
        label: 'Benchmark Self Assessment Survey',
        downloadLoading: false
      }, {
        key: 'benchmarkBoss',
        label: 'Benchmark Boss Survey',
        downloadLoading: false
      }, {
        key: 'benchmarkPeer',
        label: 'Benchmark Peer Survey',
        downloadLoading: false
      }, {
        key: 'benchmarkDirectReport',
        label: 'Benchmark Direct Report Survey',
        downloadLoading: false
      }, {
        key: 'summitSelfAssessment',
        label: 'Summit Self Assessment Survey',
        downloadLoading: false
      }, {
        key: 'summitBoss',
        label: 'Summit Boss Survey',
        downloadLoading: false
      }, {
        key: 'summitPeer',
        label: 'Summit Peer Survey',
        downloadLoading: false
      }, {
        key: 'summitDirectReport',
        label: 'Summit Direct Report Survey',
        downloadLoading: false
      }],
      surveyResult: null,
      surveyFormChanged: false,
      timeZoneList: _lifehikesInitData.ianaTimeZone,
      // reminder
      collapseActiveNames: ['setting', 'benchmark', 'summit', 'benchmarkReminder', 'summitReminder', 'report'],
      days: [{
        label: 'Monday',
        value: 1
      }, {
        label: 'Tuesday',
        value: 2
      }, {
        label: 'Wednesday',
        value: 3
      }, {
        label: 'Thursday',
        value: 4
      }, {
        label: 'Friday',
        value: 5
      }, {
        label: 'Saturday',
        value: 6
      }, {
        label: 'Sunday',
        value: 0
      }],
      // dialog
      dialogSurveyVisible: false,
      selectedSurveyKey: '',
      surveyQuery: {
        page: 1,
        limit: 99,
        q: undefined,
        sort: 'title'
      },
      surveyOptions: [],
      surveyTableLoading: false
    };
  },
  watch: {
    surveyForm: {
      handler() {
        this.$emit('updateSurvey', _lodash.default.cloneDeep(this.surveyForm));
      },
      deep: true
    },
    'surveyForm.benchmarkSelfAssessment': 'surveyFormChangedHandler',
    'surveyForm.benchmarkBoss': 'surveyFormChangedHandler',
    'surveyForm.benchmarkPeer': 'surveyFormChangedHandler',
    'surveyForm.benchmarkDirectReport': 'surveyFormChangedHandler',
    'surveyForm.summitSelfAssessment': 'surveyFormChangedHandler',
    'surveyForm.summitBoss': 'surveyFormChangedHandler',
    'surveyForm.summitPeer': 'surveyFormChangedHandler',
    'surveyForm.summitDirectReport': 'surveyFormChangedHandler',
    'surveyForm.start': {
      handler: 'surveyFormChangedHandler',
      deep: true
    },
    'surveyForm.end': {
      handler: 'surveyFormChangedHandler',
      deep: true
    },
    'surveyForm.summitStart': {
      handler: 'surveyFormChangedHandler',
      deep: true
    },
    'surveyForm.summitEnd': {
      handler: 'surveyFormChangedHandler',
      deep: true
    }
  },
  methods: {
    capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    openSurveyDialog(surveyKey) {
      this.dialogSurveyVisible = true;
      this.selectedSurveyKey = surveyKey;
      this.getSurveys();
    },
    getSurveys() {
      this.surveyTableLoading = true;
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      (0, _hike.getSurveys)(token, this.surveyQuery).then(response => {
        const data = response.data;
        this.surveyOptions = data.rows;
        this.surveyTableLoading = false;
      }).catch(error => {
        (0, _log.showDebugLog)('Survey-API-response', error);
        this.surveyTableLoading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    addSurvey(surveyId) {
      this.surveyForm[this.selectedSurveyKey] = surveyId;
      this.selectedSurveyKey = '';
      this.dialogSurveyVisible = false;
    },
    exportSurveyResult(survey) {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      survey.downloadLoading = true;
      (0, _hike.getExportSurveyResult)(token, {
        hikeId: this.parentId,
        surveyId: this.surveyForm[survey.key]
      }).then(response => {
        (0, _log.showDebugLog)('exportSurveyResult-response', response);
        this.surveyResult = response.data;
        if (this.surveyResult.length > 0) {
          this.header = this.surveyResult[0].answers;
        }
        this.handleDownload(survey);
      }).catch(error => {
        (0, _log.showDebugLog)('hike-ExportSurveyResult-error', error);
        survey.downloadLoading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    handleDaysInputBlur(type) {
      const reminderSetting = this.surveyForm.reminderSetting[type];
      if (reminderSetting.lastNotifyBeforeEffectiveEnd === undefined) {
        reminderSetting.lastNotifyBeforeEffectiveEnd = 1;
      }
    },
    handleDownload(survey) {
      Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/vendor/Export2Excel'))).then(excel => {
        const xdata = this.buildExcelData();
        excel.export_json_to_excel({
          header: xdata.header,
          data: xdata.data,
          filename: survey.label
        });
        survey.downloadLoading = false;
      });
    },
    buildExcelData() {
      var excelData = [];
      var excelHeader = [];
      // build first 4 header rows
      for (var i = 0; i < 4; i++) {
        var row = [];
        row.push(" ");
        row.push(" ");
        row.push(" ");
        row.push(" ");
        row.push(" ");
        if (i == 0) row.push('pageId');
        if (i == 1) row.push('questionId');
        if (i == 2) row.push('questionText');
        if (i == 3) row.push('logicTag');
        if (this.surveyResult.length > 0) {
          for (var j = 0; j < this.header.length; j++) {
            if (i == 0) row.push(this.header[j].pageId + ' ');
            if (i == 1) row.push(this.header[j].questionId + ' ');
            if (i == 2) row.push(this.header[j].questionText + ' ');
            if (i == 3) row.push(this.header[j].logicTag + ' ');
          }
        }
        if (i == 0) {
          excelHeader = row;
        } else {
          excelData.push(row);
        }
      }

      // build data row
      for (var x = -1; x < this.surveyResult.length; x++) {
        var row = [];
        // data row header
        if (x == -1) {
          row.push("hikeId");
          row.push("SurveyId");
          row.push("category");
          row.push("participant Uuid");
          row.push("Participant Name");
          row.push("Responent Email (This is filler email)");
          if (this.surveyResult.length > 0) {
            for (var z = 0; z < this.header.length; z++) {
              row.push('answer');
            }
          }
        } else {
          row.push(this.surveyResult[x].hikeId);
          row.push(this.surveyResult[x].surveyId);
          row.push(this.surveyResult[x].category);
          row.push(this.surveyResult[x].participantUuid);
          row.push(this.surveyResult[x].participantGivenName + ' ' + this.surveyResult[x].participantFamilyName);
          row.push(this.surveyResult[x].participantEmail);
          if (this.surveyResult.length > 0) {
            for (var z = 0; z < this.header.length; z++) {
              var answer = this.surveyResult[x].answers[z] ? this.surveyResult[x].answers[z].answer : '';
              row.push(answer);
            }
          }
        }
        excelData.push(row);
      }
      return {
        data: excelData,
        header: excelHeader
      };
    },
    clearSurvey(surveyKey) {
      this.surveyForm[surveyKey] = '';
    },
    copyEndTime(type) {
      const stage = this.parentStages.find(s => s.type === type);
      if (stage) {
        if (type === 'benchmark') {
          this.surveyForm.end = _lodash.default.cloneDeep(stage.start);
        } else {
          this.surveyForm.summitEnd = _lodash.default.cloneDeep(stage.start);
        }
      } else {
        (0, _log.displayPopupMessage)(`No ${type} stage`, 'error');
      }
    },
    sendReminderEmail(type, reminderType) {
      if (!(this.surveyForm.benchmarkSelfAssessment && this.surveyForm.benchmarkBoss && this.surveyForm.benchmarkPeer && this.surveyForm.benchmarkDirectReport && this.surveyForm.summitSelfAssessment && this.surveyForm.summitBoss && this.surveyForm.summitPeer && this.surveyForm.summitDirectReport)) {
        this.$message({
          message: 'Please fill out all Survey fields before sending the email.',
          type: 'error'
        });
        return;
      }
      if (!(this.surveyForm.start.utc !== '' && this.surveyForm.end.utc !== '' && this.surveyForm.summitStart.utc !== '' && this.surveyForm.summitEnd.utc !== '')) {
        this.$message({
          message: 'Please fill out the Effective Date & Time before sending the email.',
          type: 'error'
        });
        return;
      }
      if (this.surveyFormChanged) {
        this.$message({
          message: 'Please Publish the Hike before sending the email. ',
          type: 'error'
        });
        return;
      }
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.loading = true;
      (0, _hike.reminderTrigger)(token, {
        hikeId: this.parentId,
        surveyCategory: type,
        reminderType
      }).then(response => {
        if (response.data.message[0].includes('is sent')) {
          const msg = this.capitalize(type) + (reminderType === 'weekly' ? ' weekly reminder' : ' final notification') + ' email has been sent';
          (0, _log.displayPopupMessage)(msg, 'success');
        } else {
          (0, _log.displayPopupMessage)(response.data.message[0], 'error');
        }
        this.loading = false;
      }).catch(error => {
        (0, _log.displayPopupMessage)(error, 'error');
        this.loading = false;
      });
    },
    surveyFormChangedHandler() {
      this.surveyFormChanged = true;
    },
    resetSurveyFormChangedStatus() {
      this.surveyFormChanged = false;
    }
  }
};